import AbstractComponent from 'components/AbstractComponent';

import EmitterManager from '../managers/EmitterManager';
import { VIEW_READY } from 'core/Events';

import Dropdown from 'components/Dropdown';
import Accordion from 'components/Accordion';
import Modal from 'components/Modal';
import Carousel from 'components/Carousel';
import Header from 'components/Header';
import Footer from 'components/Footer';
import Product from 'components/Product';
import Cookies from 'components/Cookies';
import AnnouncementBar from 'components/AnnouncementBar';
import RichText from 'components/RichText';
import LoopText from 'components/LoopText';
import SVGAnimation from 'components/SVGAnimation';
import RevealGroup from 'components/RevealGroup';
import DraggableScroll from 'components/DraggableScroll';
import Scrollbar from 'components/Scrollbar';
import Lottie from 'components/Lottie';
import PushMultiProduct from 'components/PushMultiProduct';
import Video from 'components/Video';

class AbstractView extends AbstractComponent {
  constructor() {
    super(...arguments);
  }

  enter() {}

  initializeBeforeEvents() {
    super.initializeBeforeEvents();
    this.registerComponents();
  }

  initialize() {
    EmitterManager.emit(VIEW_READY, this);
  }

  registerComponents() {
    const { $element } = this;

    const $header = $element.querySelector('.header');
    const $footer = $element.querySelector('.footer');
    const $announcement = $element.querySelector('.announcement-bar');

    const $dropdowns = [...$element.querySelectorAll('.dropdown')];
    const $accordions = [...$element.querySelectorAll('.accordion')];
    const $modals = [...$element.querySelectorAll('.modal:not(.modal--cart)')];
    const $carousels = [...$element.querySelectorAll('.carousel:not([data-auto-init="false"]')];
    const $products = [...$element.querySelectorAll('.product')];
    const $cookies = [...$element.querySelectorAll('.cookies')];
    const $richTexts = [...$element.querySelectorAll('.rte--blog')];
    const $loopText = [...$element.querySelectorAll('.loop-text')];
    const $svgAnimation = [...$element.querySelectorAll('.svg-animation')];
    const $lottie = [...$element.querySelectorAll('.lottie')];
    const $revealGroups = [...$element.querySelectorAll('.reveal-group')];
    const $draggableScroll = [...$element.querySelectorAll('.draggable-scroll')];
    const $scrollbars = [...$element.querySelectorAll('.scrollbar')];
    const $pushMultiProduct = [...$element.querySelectorAll('.push-multi-product')];
    const $videos = [...$element.querySelectorAll('.video')];

    this.header = new Header({ $element: $header });
    this.footer = new Footer({ $element: $footer });

    if ($announcement) {
      this.announcement = new AnnouncementBar({ $element: $announcement });
    }

    this.dropdowns = $dropdowns.map(($element) => new Dropdown({ $element }));
    this.accordions = $accordions.map(($element) => new Accordion({ $element }));
    this.modals = $modals.map(($element) => new Modal({ $element }));
    this.carousels = $carousels.map(($element) => new Carousel({ $element }));
    this.products = $products.map(($element) => new Product({ $element }));
    this.cookies = $cookies.map(($element) => new Cookies({ $element }));
    this.richTexts = $richTexts.map(($element) => new RichText({ $element }));
    this.loopText = $loopText.map(($element) => new LoopText({ $element }));
    this.svgAnimation = $svgAnimation.map(($element) => new SVGAnimation({ $element }));
    this.lottie = $lottie.map(($element) => new Lottie({ $element }));
    this.revealGroups = $revealGroups.map(($element) => new RevealGroup({ $element }));
    this.draggableScroll = $draggableScroll.map(($element) => new DraggableScroll({ $element }));
    this.scrollbars = $scrollbars.map(($element) => new Scrollbar({ $element }));
    this.pushMultiProduct = $pushMultiProduct.map(($element) => new PushMultiProduct({ $element }));
    this.videos = $videos.map(($element) => new Video({ $element }));
  }
}

export default AbstractView;
